import React from 'react';
import { Container, Card, CardBody, Col } from 'reactstrap'
import classNames from "classnames";
import BrandedIcon from '../../BrandingWhiteLabel/BrandedIcon';

const ExpiredTokenError = ({ styles, accountName, handleLoadCertificate, handleResendEmail }) => {

  return (
    <Container className="contentWrapper">
        <Card>
            <CardBody className={classNames(styles.processingCert, "m-5")}>
              <BrandedIcon accountName={accountName} iconType={'email'} />
              <h1 className="h3 pt-5">{"Your coverage details link has expired."}</h1>
              <p className="text-center">
                {"We apologize for the inconvenience, please use the button below to request a new link."}
              </p>
              <button className="btn-secondary" onClick={() => {
                handleResendEmail()
              }}>
                {"Resend Email"}
              </button>
            </CardBody>
        </Card>
    </Container>
  )
}

export default ExpiredTokenError;